import { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import breakpointPropTypes from 'core/utils/prop-types/breakpoint';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import withBreakpoint from 'core/hocs/withBreakpoint';
import withTheme from 'core/hocs/withTheme';

import Link from 'core/components/Link';

function Social(props, context) {
  const {
    breakpoint,
    theme: { socials },
    socials: socialButtons,
  } = props;

  const { socials: contextSocialButtons } = context;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
          width 36px
          height 36px
          border-radius 18px
          opacity 1
          display flex
          align-items center
          justify-content center

          &:hover
            opacity .9

          .mobile &
            width 32px
            height 32px
            border-radius 17px
      `}</style>
    </scope>
  );

  return (
    <Fragment>
      <style jsx>{`
        .social
          list-style none
          display flex
          flex-wrap nowrap
          padding 0
          margin 0 -6px
          &.mobile
            justify-content center

        .item
          margin 6px

        .icon
          & :global([id*="$"])
            fill #fff
      `}</style>
      <ul className={cx('social', [breakpoint])}>
        {
          [].concat(socialButtons || contextSocialButtons).map(item => {
            const {
              icon: Icon,
              color: iconColor,
              height: iconHeight = 18,
              width: iconWidth = 18,
            } = socials[item.name] || {};

            if (!Icon) return null;

            return (
              <li key={item.name} className='item'>
                <Link
                  to={item.link}
                  style={{ background: iconColor }}
                  className={scope.wrapClassNames('link')}
                  aria-label={item.name}
                >
                  <Icon
                    className='icon'
                    height={iconHeight}
                    width={iconWidth}
                  />
                </Link>
              </li>
            );
          })
        }
      </ul>
      <scope.styles />
    </Fragment>

  );
}

Social.propTypes = {
  /** @ignore */
  breakpoint: breakpointPropTypes(),
  /** @ignore */
  theme: PropTypes.object,
  /** Массив социалок для отображения компонентом */
  socials: PropTypes.array,
};

Social.contextTypes = {
  socials: PropTypes.array,
};

const SocialWithHOCs = withBreakpoint(withTheme(Social));
SocialWithHOCs.displayName = 'Social';

export { Social as StorybookComponent };
export default SocialWithHOCs;
